import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import dateicon from '../../../assets/images/date-icons.png';
import WarningModal from '../../common/WarningModal';
import TranslateFile from '../../../Loc/TranslateFile';
import Button from '../../common/ui/Button';
import { authActions } from '../../../_store';
import { getStoredValue, setStoredValue } from "../../../_helpers/storageHelper";

function DropdownNotification() {
	const navigate = useNavigate();
	const loginResponse = useSelector(state => state.kioskLogin.loginResponse);
	const storedloginResponse = getStoredValue("loginResponse") || loginResponse;

	const [isActive, setIsActive] = useState(true);
	const [timeLeft, setTimeLeft] = useState(300); // Set to 10 seconds
	const storedKioskRestrictIntervalValidate = getStoredValue("KioskRestrictIntervalValidate");
	const [isShowAlert, setisShowAlert] = useState(false)
	const currentLang = TranslateFile();
	const [language, setLanguage] = useState(getStoredValue("lang") || "en"); // Default language is English
	const dispatch = useDispatch();
	
	const logout = () => {
		 setIsActive(false); setisShowAlert(false);
		 dispatch(authActions.logout());
	};

	useEffect(() => {
		if (!isShowAlert) {
			let inactivityTimer;

			const resetTimer = () => {
				setIsActive(true);
				setTimeLeft(300); // Reset timer to 10 seconds
				clearTimeout(inactivityTimer);
				// inactivityTimer = setTimeout(handleLogoutWarning, 5 * 1000); // Show warning after 5 seconds
			};

			window.addEventListener('mousemove', resetTimer);
			window.addEventListener('keydown', resetTimer);
			window.addEventListener('click', resetTimer);

			// inactivityTimer = setTimeout(handleLogoutWarning, 5 * 1000); // Show warning after 5 seconds

			return () => {
				clearTimeout(inactivityTimer);
				window.removeEventListener('mousemove', resetTimer);
				window.removeEventListener('keydown', resetTimer);
				window.removeEventListener('click', resetTimer);
			};
		}
	}, [isShowAlert]);

	useEffect(() => {
		if (!isActive || timeLeft <= 0) return;

		const countdownInterval = setInterval(() => {
			setTimeLeft(prevTime => {
				if (prevTime === 11) {
					Swal.close();
					setisShowAlert(true);
				}
				if (prevTime <= 1) {
					clearInterval(countdownInterval);
					setisShowAlert(false); // Close the alert
					logout(); // Log out when time reaches zero
					return 0;
				}
				return prevTime - 1;
			});
		}, 1000);

		return () => clearInterval(countdownInterval);
	}, [isActive, timeLeft]);

	const getCurrentDateTime = () => {
		const utcNow = new Date(); // Get the current UTC time

		// Convert UTC time to Eastern Time
		const options = { timeZone: "America/New_York" };
		const easternDate = new Date(
			utcNow.toLocaleString("en-US", options)
		);

		// Format the date as MM-dd-yyyy HH:mm (24-hour format) and AM/PM
		const month = String(easternDate.getMonth() + 1).padStart(2, "0");
		const day = String(easternDate.getDate()).padStart(2, "0");
		const year = easternDate.getFullYear();
		const hours24 = String(easternDate.getHours()).padStart(2, "0");
		const minutes = String(easternDate.getMinutes()).padStart(2, "0");
		const isPM = easternDate.getHours() >= 12;
		const period = isPM ? "PM" : "AM";

		const formattedTime = `${month}-${day}-${year} ${hours24}:${minutes} ${period}`;
		return formattedTime;
	};


	const handleToggle = (e) => {
		const isChecked = e.target.checked; // This will be true if the toggle is ON, false otherwise
		setLanguage(isChecked ? 'en' : 'es');
		setStoredValue("lang", isChecked ? 'en' : 'es'); window.location.reload();
	};


	return (
		<>

			{storedKioskRestrictIntervalValidate?.DisplayCurrentDate == 1 && <div className="header-left">
				<img className='headerIcon' src={dateicon} alt="Logo" />
				<span className="header-date">{getCurrentDateTime()}</span>
			</div>}

			<div className="header-right">
				<span className="lang-text">{currentLang?.Select_Language}</span>
				<div className="language-toggle">
					<label className="toggle-switch">
						<input
							type="checkbox"
							checked={language === "en"}
							onChange={(e) => { handleToggle(e) }}
						/>
						<span className="slider" style={{ justifyContent: language === "en" ? 'flex-start' : 'flex-end' }}>
							{(getStoredValue("lang") || "en")?.toUpperCase()}
						</span>
					</label>
				</div>
				<div className="header-right-content">
					<span className="header-username">
						{/* <img className='headerIcon' src={userProfile} alt="User" /> */}
						<div className="display-block-for-profile">
							<span className='mb-0 welcome-text'><span className='fw-500'>{currentLang?.Welcome} </span><span className='text-default-red'>{storedloginResponse?.InmateFullName?.length > 15
								? `${storedloginResponse.InmateFullName.slice(0, 15)}...`
								: storedloginResponse?.InmateFullName}</span></span>
							<span className="session-expiry">
								{currentLang?.Session_expire} <span className="text-default-red fw-700">{timeLeft}</span> {currentLang?.Secs}
							</span>
						</div>

					</span>

				</div>
				<div className='logout-btn'>
					<Button
						className='btn-danger'
						label={currentLang?.Logout}
						type="button"
						status="back"
						onClick={logout}
					/>
				</div>
			</div>

			{isShowAlert && (
				<WarningModal
					onLogout={() => { logout() }}
					onExtendSession={() => { setisShowAlert(false) }}
					timeLeft={timeLeft}
				/>
			)}
		</>
	);
};

export default memo(DropdownNotification);
